import { render, staticRenderFns } from "./MyLabelIsEnable.vue?vue&type=template&id=383e7664&scoped=true&"
import script from "./MyLabelIsEnable.vue?vue&type=script&lang=js&"
export * from "./MyLabelIsEnable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383e7664",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('383e7664')) {
      api.createRecord('383e7664', component.options)
    } else {
      api.reload('383e7664', component.options)
    }
    module.hot.accept("./MyLabelIsEnable.vue?vue&type=template&id=383e7664&scoped=true&", function () {
      api.rerender('383e7664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/MyLabelIsEnable.vue"
export default component.exports